import { IDefineCommand } from 'core-ts-types';
import * as _4 from 'lodash4';
import { IPlanFeebackCourseGroupsDatasource } from '../../plan_feedback/datasources/plan_feedback_course_groups_datasource';
import { IPlanFeebackCoursesDatasource } from '../../plan_feedback/datasources/plan_feedback_courses_datasource';
import { IPlanFeedbackProgramSlotsDatasource } from '../../plan_feedback/datasources/plan_feedback_program_slots_datasource';
import { IPlanFeebackTermsDatasource } from '../../plan_feedback/datasources/plan_feedback_terms_datasource';
import { FeedbackSuggestedPlanModel } from '../../plan_feedback/models/feedback_suggested_plan_model';
import { ConflictingSuggestionsModel } from '../models/conflicting_suggestions_model';

angular
  .module('capability-ng-academic-planner')
  .service(
    'loadBlockedSuggestionsCommand',
    function loadBlockedSuggestionsCommand(
      $http: ng.IHttpService,
      log: any,
      ngConflictingSuggestionsModel: ConflictingSuggestionsModel,
      ngPlanFeebackCourseGroupsDatasource: IPlanFeebackCourseGroupsDatasource,
      ngPlanFeebackCoursesDatasource: IPlanFeebackCoursesDatasource,
      ngPlanFeebackTermsDatasource: IPlanFeebackTermsDatasource,
      ngFeedbackSuggestedPlanModel: FeedbackSuggestedPlanModel,
      ngPlanFeedbackProgramSlotsDatasource: IPlanFeedbackProgramSlotsDatasource,
      defineCommandORM: IDefineCommand
    ) {
      return defineCommandORM('loadBlockedSuggestionsCommand', (deferred) => {
        $http
          .get(`/academicplan/suggested_plan/${ngFeedbackSuggestedPlanModel.read().id}/diff_with_conflicts/`)
          .then(({ data }: any) => {
            ngPlanFeedbackProgramSlotsDatasource.clear().write(data.feedback_programslot_statuses);

            ngPlanFeebackCoursesDatasource.clear().write(data.feedback_courses);

            ngPlanFeebackCourseGroupsDatasource.clear().write(data.feedback_course_groups);

            ngPlanFeebackTermsDatasource.clear().write(data.feedback_terms);

            ngConflictingSuggestionsModel.clear().write({
              conflicting_resolution_ids: data.conflicting_resolution_ids
            });
            deferred.resolve();
          })
          .catch((e: any) => {
            deferred.reject(e);
          });
      });
    }
  );



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-academic-planner/src/suggestions/components/blocked_suggestions/commands/load_blocked_suggestions_command.ts